import { PDFDownloadLink } from "@react-pdf/renderer";
import styled from "styled-components";

import { StyledButton } from "../../OrderHeader";
import { Props } from "../ClearOrderDocument";
import { AbnDocument } from "./AbnDocument";

const StyledPDFDownloadLink = styled(PDFDownloadLink)`
  text-decoration: none;
  color: var(--primary-color);
`;

type DownloadAbnProps = {
  data: Props;
  isLogoLoading?: boolean;
};

export function DownloadAbn({ data, isLogoLoading = false }: DownloadAbnProps) {
  // Show loading state while logo is being fetched
  if (isLogoLoading) {
    return (
      <StyledButton
        className="p-button-text p-button-primary p-0 mb-0"
        icon="pi pi-spin pi-spinner"
        disabled
      >
        <span style={{ textDecoration: "none", color: "var(--primary-color)" }}>
          Loading...
        </span>
      </StyledButton>
    );
  }

  return (
    <StyledButton
      className="p-button-text p-button-primary p-0 mb-0"
      icon="pi pi-file"
    >
      <StyledPDFDownloadLink
        document={<AbnDocument {...data} />}
        fileName={`abn_document__${new Date().getTime()}.pdf`}
      >
        {({ loading }) => (loading ? "Loading..." : "Download ABN")}
      </StyledPDFDownloadLink>
    </StyledButton>
  );
}
